import { IconButton, Tooltip } from "@chakra-ui/react";
import { Toast } from "components/toast";
import { CopyIcon } from "components/ui/vectors/copy-icon";

export const CopyButton = ({
  text,
  copyMessage,
}: {
  text?: string;
  copyMessage?: string;
}) => {
  return (
    <Tooltip label={"Copiar"}>
      <IconButton
        size="sm"
        aria-label="Copiar"
        background={"white"}
        h="0px !important"
        onClick={async (ev) => {
          ev.stopPropagation();
          ev.preventDefault();
          await navigator.clipboard.writeText(text ?? "");
          Toast({
            title: "Copiar",
            description: copyMessage ?? "Texto copiado com sucesso",
            duration: 3000,
          });
        }}
        icon={
          <CopyIcon
            width={"15px"}
            height={"15px"}
            color="var(--chakra-colors-brand-500)"
            _hover={{
              color: "var(--chakra-colors-brand-600)",
            }}
          />
        }
      />
    </Tooltip>
  );
};
